// $.fn.datepicker.defaults.format = "yyyy-mm-dd";
require('./views')
require('./scrollable')
require('./sidebar')
